export default {
	default: [''],
	condensed: ['toggle--condensed']
};
